import React from 'react';
import { Tooltip as UniTooltip, TooltipProps as UniTooltipProps } from '@planne-software/uni/Tooltip';
import { ScopedCssBaseline } from '@planne-software/uni/mui/material';

interface TooltipProps extends UniTooltipProps {
  showContent?: boolean;
}

export const Tooltip = (props: TooltipProps) => {
  const { showContent, children, ...rest } = props;

  if (!showContent) {
    return children;
  }

  return (
    <ScopedCssBaseline sx={{ width: '100%' }}>
      <UniTooltip {...rest}>{children}</UniTooltip>
    </ScopedCssBaseline>
  );
};
